import { Navigate, useParams } from "react-router-dom";

/** Redirect legacy /articles/* URLs to /learning-hub/* */
export function ArticlesIndexRedirect() {
    return <Navigate to="/learning-hub" replace />;
}

export function ArticlesSlugRedirect() {
    const { slug } = useParams();
    if (!slug) {
        return <Navigate to="/learning-hub" replace />;
    }
    return <Navigate to={`/learning-hub/${slug}`} replace />;
}
